import { createContext } from "react"

const BusinessTypeOpeningsContext = createContext();

export default BusinessTypeOpeningsContext;